module.exports = __webpack_public_path__ + "static/media/Netherland_Argentina.66c5bb1d.jpeg";